<div class="littleAboutUs" [ngClass]="{'showHiddenMessage' : showHiddenMessage}">
    <div class="mw">
        <div class="row popGirl" >
            <div class="sm-12 md-12 xl-8" [ngClass]="{'offset-2' : brand === 'winaija' && !isMobile}">
                <div class="mobile-container" [ngClass]="{'center' : brand === 'winaija' && !isMobile}">
                    <h2>{{ 'static.lau' | translate }}</h2>
                    <p>{{ 'static.lauBody' | translate }}</p>
                </div>

                <!--MOBILE-->
                <div class="mobile-show security-header">
                    <img *ngIf="brand === 'qiwi'" src="../../../assets/images/newCircleIcons/shield.svg"/>
                    <img *ngIf="brand === 'winaija'" src="../../../assets/images/little-about-us/ico_100Secure-Winaija.svg"/>
                    <h4>{{ 'static.security' | translate }}</h4>
                </div>
                <!--END MOBILE-->

                <div class="row icons">
                    <div class="fl sm-6 md-6 xl-6">
                        <div class="row">
                            <div class="fl sm-3 md-3 xl-3">
                                <img *ngIf="brand === 'qiwi'" src="../../../assets/images/newCircleIcons/shield.svg"/>
                                <img *ngIf="brand === 'winaija'" src="../../../assets/images/little-about-us/ico_100Secure-Winaija.svg"/>
                            </div>
                            <div class="fl sm-9 md-9 xl-9">
                                <h4>{{ 'static.secure' | translate }}</h4>
                                <p>{{ 'static.secureBody' | translate }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="fl sm-6 md-6 xl-6">
                        <div class="row">
                            <div class="fl sm-3 md-3 xl-3">
                                <img *ngIf="brand === 'qiwi'" src="../../../assets/images/newCircleIcons/hand-money.svg"/>
                                <img *ngIf="brand === 'winaija'" src="../../../assets/images/little-about-us/ico_moneyBackGuarantee-Winaija.svg"/>
                            </div>
                            <div class="fl sm-9 md-9 xl-9">
                                <h4>{{ 'static.mbg' | translate }}</h4>
                                <p>{{ 'static.mbgBody' | translate }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="fl sm-6 md-6 xl-6">
                        <div class="row">
                            <div class="fl sm-3 md-3 xl-3">
                                <img *ngIf="brand === 'qiwi'" src="../../../assets/images/newCircleIcons/wall.svg"/>
                                <img *ngIf="brand === 'winaija'" src="../../../assets/images/little-about-us/ico_customerSupport-Winaija.svg"/>
                            </div>
                            <div class="fl sm-9 md-9 xl-9">
                                <h4>{{ 'static.cs' | translate }}</h4>
                                <p>{{ 'static.csBody' | translate }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="fl sm-6 md-6 xl-6">
                        <div class="row">
                            <div class="fl sm-3 md-3 xl-3">
                                <img *ngIf="brand === 'qiwi'" (click)="count()" src="../../../assets/images/newCircleIcons/mail.svg"/>
                                <img *ngIf="brand === 'winaija'" (click)="count()" src="../../../assets/images/little-about-us/ico_spamFree-Winaija.svg"/>
                            </div>
                            <div class="fl sm-9 md-9 xl-9">
                                <h4>{{ 'static.spam' | translate }}</h4>
                                <p>{{ 'static.spamBody' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
